/**
 * 平台: 小程序webview
 * 通用能力:
 * 1.bridge：mpReady (window.my | window.wx)
 * 2.登录: mpLogin
 * 3.定位: mpLocate
 * 4.订阅: mpSubscribe
 * 5.分享: mpShare
 */
import { utils } from '@didi/webx-js-core';
import { build } from '../../../query';
import { is } from '../../../xenv';
import { weixinReady, weixinLocate } from './weixin';
import { sdkReady } from '../../loader';
import { MiniprogramJump, AliprogramJump } from './goTo';
import { query, hashQuery } from './../../../query';
// import mpBridge from '@didi/webx-mp-bridge'
import pageShow from '../../../utils/pageShow';
import { request } from '../../../request';
import { storage } from '../../../storage';
/**
 * 微信小程序commonJump dchnJump
 */
function wxCommonJump(loadParams, xenv, commonParams = {}) {
    new MiniprogramJump(loadParams, xenv, commonParams).doJump();
}
/**
 * 微信小程序commonJump dchnJump
 */
function aliCommonJump(loadParams, xenv, commonParams = {}) {
    new AliprogramJump(loadParams, xenv, commonParams).doJump();
}
/**
 * 支付宝小程序webview bridgeReady
 */
const alimpReady = (callback) => {
    const _alipayMpSDK = 'https://appx/web-view.min.js';
    sdkReady('my', _alipayMpSDK, sdk => {
        if (sdk.constructor === Error) {
            callback(sdk);
        }
        else {
            if (window.my) {
                window.__alipayMpReady__ = true;
                callback(window.my);
            }
            else {
                window.__alipayMpReady__ = false;
                callback(sdk);
            }
        }
    });
};
const weixinmpReady = (fn) => {
    weixinReady(fn, { needConfig: false });
};
/**
 * mpReady
 * @description 通用webview做抹平的ready功能
 *   兼容微信和支付宝
 */
const mpReady = (fn) => {
    if (is('weixin')) {
        weixinmpReady(fn);
        return;
    }
    else if (is('alipay')) {
        alimpReady(fn);
        return;
    }
};
/**
 * getBridge
 * @description 通用webview获取bridge
 *   兼容微信和支付宝
 */
function getBridge() {
    if (is('weixin')) {
        return window.wx.miniProgram;
    }
    else if (is('alipay')) {
        return window.my;
    }
}
/**
 * mpSetShare
 * @description 通用webview设置分享
 *   兼容微信和支付宝
 */
const mpSetShare = (option) => {
    mpReady(() => {
        getBridge().postMessage(option);
    });
};
/**
 * mpDisableShare
 * @description 通用webview禁用分享
 *   兼容微信和支付宝
 */
const mpDisableShare = () => {
    mpReady(() => {
        getBridge().postMessage({
            data: {
                type: 'hideShareMenu'
            }
        });
    });
};
/**
 * mpInvokeShare
 * @description 通用webview发起分享
 *   兼容微信
 */
const mpInvokeShare = (option) => {
    if (option.activity_id) {
        mpReady(() => {
            getBridge().navigateTo({
                url: build('/webx-mp-next/transfer-station/index?type=share', option, false)
            });
            // mpBridge.call('share', {
            //   activity_id: option.activity_id || '',
            //   share_title: option.share_title || '',
            //   share_subTitle: option.share_subTitle || '',
            //   share_imgUrl: encodeURIComponent(option.share_imgUrl || ''),
            //   share_sharePath: option.share_sharePath || '',
            //   share_shareImgUrl: option.share_shareImgUrl || '',
            //   poster_img_url: option.poster_img_url || '',
            //   poster_title: option.poster_title || '',
            //   poster_sub_title: option.poster_sub_title || '',
            //   poster_btn_text: option.poster_btn_text || ''
            // })
        });
    }
    else {
        mpInvokeShareMask();
    }
};
const getPx = (num) => {
    let radio = document.documentElement.clientWidth / 750;
    return `${num * radio}px`;
};
/**
 * mpInvokeShareMask
 * @description webview环境下 无主动分享机制时 蒙层兜底
 *   兼容微信
 */
const mpInvokeShareMask = () => {
    const shadowImg = '//dpubstatic.udache.com/static/dpubimg/0e3e87f7-215c-48c2-9320-26577ad72bd2.png';
    const $dom = document.createElement('div');
    $dom.style.position = 'fixed';
    $dom.style.width = '100%';
    $dom.style.height = '100%';
    $dom.style.left = '0';
    $dom.style.top = '0';
    $dom.style.backgroundColor = 'rgba(0,0,0,.6)';
    $dom.style.zIndex = '10000';
    $dom.style.backgroundImage = `url(${shadowImg})`;
    $dom.style.backgroundRepeat = 'no-repeat';
    $dom.style.backgroundSize = `${getPx(270)} auto`;
    $dom.style.backgroundPositionY = '0';
    $dom.style.backgroundPositionX = getPx(650 - 270);
    setTimeout(() => {
        // 延时300ms后设置onclick方法，避免移动端点击穿透
        $dom.onclick = () => {
            document.body.removeChild($dom);
        };
    }, 300);
    document.body.appendChild($dom);
};
/**
 * mpSaveImg
 * @description 通用webview保存图片
 *   兼容微信和支付宝
 */
const mpSaveImg = (option) => {
    mpReady(() => {
        getBridge().navigateTo({
            url: build('/webx-mp-next/transfer-station/index?type=share', option)
        });
        // mpBridge.call('share', option)
    });
};
/**
 * mpIsLogin
 * @description 通用webview登录
 *   兼容微信和支付宝
 */
const mpIsLogin = ((option, callback) => {
    return new Promise((resolve, reject) => {
        const queryObj = Object.assign({}, query(), hashQuery());
        const { useQuick } = option || {};
        if (queryObj.token) {
            const userInfo = {
                token: queryObj.token
            };
            /* 获取用户信息成功 存入缓存 */
            storage.userInfo = {
                ...userInfo
            };
            let newRiskParams = Object.assign({}, storage.riskParams, { newTicket: queryObj.token });
            utils.cleanEmptyKey(newRiskParams);
            storage.riskParams = newRiskParams;
            /* 执行传入cb */
            useQuick && callback && callback({ ...userInfo });
            resolve({ ...userInfo });
        }
        else {
            /* 获取用户信息成功 存入缓存 */
            storage.userInfo = {};
            let newRiskParams = Object.assign({}, storage.riskParams, { newTicket: undefined });
            utils.cleanEmptyKey(newRiskParams);
            storage.riskParams = newRiskParams;
            reject({});
        }
    });
});
/**
 * mpLogin
 * @description 通用webview登录
 *   兼容微信和支付宝
 */
const mpLogin = ((option) => {
    const _option = option || {};
    _option.back_url = (_option && _option.back_url) ? _option.back_url : location.href.replace(location.hash, '');
    return new Promise((success, fail) => {
        mpReady(() => {
            getBridge().redirectTo({
                url: build('/webx-mp-next/transfer-station/index?type=login', _option),
                success: () => {
                    /* 跳转登录页成功 此时并无登录信息返回!! */
                    success({ token: '' });
                },
                fail: () => {
                    /* 跳转登录页失败 此时并无登录信息返回!! */
                    fail({ token: '' });
                }
            });
            // mpBridge.call('login', {
            //   back_url: option.back_url || ''
            // })
        });
    });
});
/**
 * mpSubscribe
 * @description 通用webview订阅
 *   兼容微信和支付宝
 */
const mpSubscribe = (option) => {
    return new Promise((success, fail) => {
        mpReady(() => {
            getBridge().navigateTo({
                url: build('/webx-mp-next/transfer-station/index?type=subscribe', option),
                success,
                fail
            });
            // mpBridge.call('subscribe', {
            //   activity_id: option.activity_id || '',
            //   back_url: option.back_url || '',
            //   success,
            //   fail
            // })
        });
    });
};
const getPayStatus = (data) => {
    return new Promise((resolve, reject) => {
        request('POST', 'https://pay.udache.com/gulfstream/pay/v1/didipay/getPayStatus', {
            data: data,
            needSign: true,
            emulateJSON: true,
            giveUpNineChapter: true,
        }).catch(err => {
            reject(err);
        }).then(res => {
            if (res.errno !== 0) {
                reject(res);
            }
            else {
                if (res.data.pay_status === 3) {
                    resolve(res);
                }
                else if (res.data.pay_status === 1) {
                    reject({
                        code: 2,
                        err: res
                    });
                }
                else {
                    reject(res);
                }
            }
        });
    });
};
/**
 * mpPay
 * @description 通用webview支付
 *   兼容微信和支付宝
 */
const mpPay = (options) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { mini_url, pay, useOld, lang, out_trade_id, token, version, mini_back, ...args } = options;
    if (!pay) {
        pay = {
            out_trade_id: out_trade_id,
            token: token
        };
    }
    else {
        pay = {
            out_trade_id: pay.out_trade_id,
            token: pay.token
        };
    }
    let params = {
        options: JSON.stringify(pay),
        ...args,
    };
    if (!mini_url) {
        mini_url = '/cashier-page/pages/index';
    }
    if (mini_url !== '/cashier-page/pages/index') {
        delete params.options;
        params = {
            ...params,
            ...pay
        };
    }
    const back = mini_back || (mini_url === '/cashier-page/pages/index' && !options.successUrl);
    return new Promise((resolve, reject) => {
        back && pageShow.on('pageshow', () => {
            getPayStatus({
                out_trade_id: pay.out_trade_id || '',
                token: pay.token || ''
            }).then(() => {
                resolve({});
            }).catch(err => {
                reject(err);
            });
            pageShow.remove('pageshow');
        });
        mpReady(() => {
            getBridge().navigateTo({
                url: build(mini_url, params),
                success: () => {
                    if (!back) {
                        resolve({});
                    }
                },
                fail: (err) => {
                    reject(err);
                }
            });
        });
    });
};
/**
 * alimpLocate
 * @description 支付宝小程序webview定位
 *   兼容：因为微信小程序webview需要走wx.config,不适应这套，所以这里只实现支付宝
 */
const alimpLocate = () => {
    return new Promise((resolve, reject) => {
        alimpReady(() => {
            window.my.getLocation({
                success(res) {
                    /* 获取定位信息成功 存入缓存 */
                    storage.locationInfo = {
                        lat: res.latitude,
                        lng: res.longitude
                    };
                    let newRiskParams = Object.assign({}, storage.riskParams, { latitude: res.latitude, longitude: res.longitude });
                    utils.cleanEmptyKey(newRiskParams);
                    storage.riskParams = newRiskParams;
                    resolve({
                        lat: res.latitude,
                        lng: res.longitude
                    });
                },
                fail: (err) => {
                    /* 获取定位信息失败 存入缓存 */
                    storage.locationInfo = {};
                    let newRiskParams = Object.assign({}, storage.riskParams, { latitude: undefined, longitude: undefined });
                    utils.cleanEmptyKey(newRiskParams);
                    storage.riskParams = newRiskParams;
                    reject(err);
                }
            });
        });
    });
};
// 将微信和支付宝的按照功能各自命名分开导出
export { weixinmpReady, weixinLocate as weixinmpLocate, mpIsLogin as weixinmpIsLogin, mpLogin as weixinmpLogin, mpSaveImg as weixinmpSaveImg, mpSubscribe as weixinmpSubscribe, mpSetShare as weixinmpSetShare, mpDisableShare as weixinmpDisableShare, mpInvokeShare as weixinmpInvokeShare, mpPay as weixinmpPay, wxCommonJump as weixinmpCommonJump };
export { alimpReady, alimpLocate, mpIsLogin as alimpIsLogin, mpLogin as alimpLogin, mpSaveImg as alimpSaveImg, mpSubscribe as alimpSubscribe, mpSetShare as alimpSetShare, mpDisableShare as alimpDisableShare, mpInvokeShareMask as alimpInvokeShare, mpPay as alimpPay, aliCommonJump as alimpCommonJump };
